import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MTP_COMPLIANCE} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MTPCompliance = lazy(() =>
  import('../../../screens/MTPCompliance')
    .then(module => ({default: module.MTPCompliance})));

const MTPComplianceNavigation = [
  {
    path: ROUTE_MTP_COMPLIANCE,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MTPCompliance />
      </Suspense>
    ),
  },
];

export default MTPComplianceNavigation;
